<!-- 
	输入号码
	lovi 2020-07-30
 -->
<template>
  <div class="number-enter">
    <div class="global-dl">
      <dl class="number-info">
        <dt></dt>
        <dd>
          <div class="number-title" v-if="operatorTitle.length">
            <span v-for="(item, index) in operatorTitle" :key="index">
              {{ item }}
            </span>
          </div>
          <div class="number-total">
            <span :class="{ active: showNumber == 0 }" @click="showNum(0)">
              {{ $t("recharge.totalNumber") }}:
              {{ Alltotal }}
              {{ $t("recharge.article") }}
            </span>
            <span :class="{ active: showNumber == 1 }" @click="showNum(1)">
              {{ $t("recharge.wrongNumber") }}:
              {{ errorArr.length }}
              {{ $t("recharge.article") }}
            </span>
            <span :class="{ active: showNumber == 2 }" @click="showNum(2)">
              {{ $t("recharge.duplicateNumber") }}:
              {{ repeatArr.length }}
              {{ $t("recharge.article") }}
            </span>
          </div>
        </dd>
      </dl>
      <dl>
        <dt>{{ $t("recharge.rechargeNumber") }}：</dt>
        <dd>
          <div class="text-warp">
            <Input
              type="textarea"
              :rows="10"
              v-model="phone"
              @on-blur="inputBlur(phone)"
              @on-keyup="tabEvent($event)"
              :placeholder="$t('recharge.enterNumberTips')"
            />
          </div>
          <div class="text-handle">
            <div class="text-handle-item">
              <a @click="importPop(0)">{{ $t("recharge.import") }}Excel</a>
              <a
                @click="importPop(1)"
                :class="{ 'text-gray': tagList.length == 0 }"
                >{{ $t("recharge.importNumber") }}</a
              >
              <a @click="importPop(2)">{{
                $t("recharge.addFavoriteNumber")
              }}</a>
            </div>
            <div class="text-handle-item">
              <a class="text-orange" @click="deleteSubmit(0)">{{
                $t("recharge.wrongRemoval")
              }}</a>
              <a class="text-orange" @click="deleteSubmit(1)">{{
                $t("recharge.repetitiveRemoval")
              }}</a>
            </div>
          </div>
        </dd>
      </dl>
    </div>

    <!-- 导入excel -->
    <import-excel :excelFlag.sync="excelFlag" @getExcelData="getExcelData" />
    <!-- 导入电话簿 -->
    <import-tel
      ref="importTel"
      :importTelPop.sync="importTelPop"
      :tagList="tagList"
      @getTelData="getTelData"
    />
    <!-- 添加标签 -->
    <add-tag
      :addTagTelPop.sync="addTagTelPop"
      :tagList.sync="tagList"
      :submitLoading="submitLoading"
      @changeTagList="changeTagList"
      @addMobile="addMobile"
    />
  </div>
</template>

<script>
import ImportExcel from "./importExcel.vue";
import ImportTel from "./importTel.vue";
import AddTag from "./addTag.vue";
export default {
  props: {
    showTaskEdit: {
      //编辑开关
      type: Boolean,
      default: false
    },
    operatorTitle: {
      //充值号码的运营商列表
      type: Array,
      default: function() {
        //title 充值号码的运营商列表
        //type 充值号码运营商的类别 0是Globe(Tm) Smart Sun 1是Globe Smart Sun Tm 2是Tnt
        return [];
      }
    },
    operatorType: {
      //充值号码运营商的类别 0是Globe(Tm) Smart Sun 1是Globe Smart Sun Tm 2是Tnt
      type: Number,
      default: function() {
        return 0;
      }
    },
    rechargeType: {
      type: Number,
      default: function() {
        return null;
      }
    },
    operatorList: {
      //运营商号码段列表
      type: Array,
      default: function() {
        return [];
      }
    },
    allMoney: {
      // 所有金额面板信息
      type: Object,
      default: function() {
        return {};
      }
    },
    tagList: {
      //标签列表
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      showNumber: 0, //显示全部/错误/重复号码

      telArr: [], //导入的号码数组
      phone: "", //输入框的号码
      successArr: [], //输入的号码的成功数组
      errorArr: [], //输入的号码的错误数组
      repeatArr: [], //输入的号码的重复数组
      Alltotal: 0, //总条数

      excelFlag: false, //立即导入弹窗
      importTelPop: false, //导入电话簿弹窗
      addTagTelPop: false, //添加标签弹窗

      submitLoading: false
    };
  },
  created() {},
  mounted() {
    let vm = this;
    vm.showNumber = 0; //显示全部/错误/重复号码
    vm.telArr = []; //导入的号码数组
    vm.phone = ""; //输入框的号码
    vm.successArr = []; //输入的号码的成功数组
    vm.errorArr = []; //输入的号码的错误数组
    vm.repeatArr = []; //输入的号码的重复数组
    vm.Alltotal = 0; //总条数
    window.addEventListener("keydown", event => {
      if (event.keyCode === 9) {
        event.preventDefault();
      }
    });
  },
  computed: {},
  methods: {
    changeTagList(arr) {
      this.$emit("update:tagList", arr);
    },
    addMobile(data) {
      //将号码保存到标签
      let vm = this;
      let inputData = vm.getClassify();
      if (!inputData.arr.length) {
        vm.$Message.info(vm.$t("common.enterMobile"));
        return false;
      }
      let arr = [];
      arr = JSON.parse(JSON.stringify(vm.successArr));
      if (inputData.error || inputData.repeat) {
        vm.$Modal.confirm({
          content: vm.$t("recharge.wrongDuplicateContinueAdd"),
          onOk: function() {
            vm.userMobilesAdd(arr, data);
          },
          onCancel: function() {
            arr = [];
          }
        });
        return false;
      }
      vm.userMobilesAdd(arr, data);
    },
    userMobilesAdd(arr, data) {
      let vm = this;
      let params = {};
      params.tag = vm.tagList[data.checkTagIndex].id;
      params.mobile = arr.join(",");
      vm.submitLoading = true;
      vm.$post("/app/user/userMobilesAdd", params, { alert: true }).then(
        res => {
          vm.submitLoading = false;
          // vm.$Message.info(res.msg)
          vm.$Message.info({
            content: res.msg,
            onClose: function() {
              vm.addTagTelPop = false;
            }
          });
        }
      );
    },
    getExcelData(arr) {
      //获取到excel的数据
      let vm = this;
      console.log(arr);
      //判断数组长度
      if (!arr.length) {
        return;
      }
      vm.excelFlag = false;
      //校验号码
      vm.telArr = arr;
      vm.updateMobile();
    },
    getTelData(arr) {
      //获取到电话簿的数据
      let vm = this;
      console.log(arr);
      //判断数组长度
      if (!arr.length) {
        return;
      }
      vm.importTelPop = false;
      //校验号码
      vm.telArr = arr;
      vm.updateMobile();
    },
    showNum(type) {
      //显示当前的号码
      let vm = this;
      vm.showNumber = type;
      let newArr = [];
      if (type == 0) {
        newArr = JSON.parse(JSON.stringify(vm.telArr));
      } else if (type == 1) {
        newArr = JSON.parse(JSON.stringify(vm.errorArr));
      } else if (type == 2) {
        newArr = JSON.parse(JSON.stringify(vm.repeatArr));
      }
      for (let i = 0; i < newArr.length; i++) {
        newArr[i] = newArr[i]
          .replace(/\s/g, "")
          .replace(/(0?\d{4})(\d{3})(\d{4})/, "$1 $2 $3");
      }
      vm.phone = newArr.join(";\n");
    },
    inputBlur(val) {
      //输入号码
      let vm = this;
      if (val == "") {
        //判断当前显示的号码
        let newArr = [];
        if (vm.showNumber == 0) {
          vm.telArr = [];
          vm.errorArr = [];
          vm.repeatArr = [];
          vm.successArr = [];
        } else if (vm.showNumber == 1) {
          vm.errorArr = [];
        } else if (vm.showNumber == 2) {
          vm.repeatArr = [];
        }
        newArr = newArr
          .concat(vm.successArr)
          .concat(vm.errorArr)
          .concat(vm.repeatArr);
        vm.telArr = JSON.parse(JSON.stringify(newArr));
        vm.Alltotal = vm.telArr.length;
        return;
      }
      let newStr = val + "";
      // console.log(newStr.replace(/；/g, '@'))
      //处理换行和；分号，方便转换成数组
      newStr = newStr.replace(/\n/g, "@");
      newStr = newStr.replace(/;/g, "@");
      newStr = newStr.replace(/；/g, "@");
      //清除数据中的空格
      newStr = newStr.replace(/\s/g, "");
      let newArr = [];
      newArr = JSON.parse(JSON.stringify(vm.telArr));
      if (newStr.split("@").length) {
        let thisArr = [];
        thisArr = newStr.split("@");
        thisArr = vm.trimSpace(thisArr);
        if (vm.showNumber == 0) {
          //修改全部数据,则修改的是全部数据
          newArr = thisArr;
        } else if (vm.showNumber == 1) {
          //修改错误数据
          newArr = [];
          newArr = newArr
            .concat(thisArr)
            .concat(vm.repeatArr)
            .concat(vm.successArr);
        } else if (vm.showNumber == 2) {
          //修改重复数据
          newArr = [];
          newArr = newArr
            .concat(thisArr)
            .concat(vm.errorArr)
            .concat(vm.successArr);
        }
        vm.telArr = JSON.parse(JSON.stringify(newArr));
        vm.updateMobile();
      }
    },
    trimSpace(array) {
      //去掉数组中的空字符串
      for (var i = 0; i < array.length; i++) {
        if (
          array[i] == "" ||
          array[i] == null ||
          typeof array[i] == "undefined"
        ) {
          array.splice(i, 1);
          i = i - 1;
        }
      }
      return array;
    },
    updateMobile() {
      //校验号码
      let vm = this;
      // console.log(regArr)
      let errorArr = [];
      let successArr = [];
      // console.log(vm.telArr)
      for (let i = 0; i < vm.telArr.length; i++) {
        //先判断号码是否符合规则
        //是否是以09/09/8/9开头，并且是11/10位数字
        let thisNum = Number(vm.telArr[i]);
        let thisFirst = thisNum.toString().split("")[0];
        let thisLength = thisNum.toString().length;
        if ((thisFirst == "8" || thisFirst == "9") && thisLength == 10) {
          //再判断是否存在当前运营商号码段中，不存在则是错误号码
          let thisPhone = "0" + thisNum;
          let exist = false;
          for (let j = 0; j < vm.operatorList.length; j++) {
            let thisReg = vm.operatorList[j].tel + "";
            if (vm.operatorType == 2) {
              // TNT
              if (
                thisPhone.indexOf(thisReg) == 0 &&
                vm.operatorList[j].operator_id == 2
              ) {
                exist = true;
                break;
              }
            } else {
              if (thisPhone.indexOf(thisReg) == 0) {
                exist = true;
                break;
              }
            }
          }
          if (exist) {
            //判断成功数组中是否有该号码
            successArr.push(thisPhone);
          } else {
            //添加至错误号码中
            errorArr.push(vm.telArr[i]);
          }
        } else {
          //添加至错误号码中
          errorArr.push(vm.telArr[i]);
        }
      }
      //所有正确号码补0
      for (let i = 0; i < vm.telArr.length; i++) {
        for (let j = 0; j < successArr.length; j++) {
          if (Number(vm.telArr[i]) == Number(successArr[j])) {
            vm.telArr[i] = "0" + Number(vm.telArr[i]);
          }
        }
      }
      let newSuccess = [];
      let repeatArr = [];
      //正确的号码补0之后再判断是否存在重复号码
      for (let i = 0; i < successArr.length; i++) {
        if (newSuccess.indexOf(successArr[i]) == -1) {
          //判断newSuccess中是否包含当前号码，没有则添加
          newSuccess.push(successArr[i]);
        } else {
          repeatArr.push(successArr[i]);
        }
      }
      //赋值数组
      vm.successArr = JSON.parse(JSON.stringify(newSuccess));
      vm.repeatArr = JSON.parse(JSON.stringify(repeatArr));
      vm.errorArr = JSON.parse(JSON.stringify(errorArr));
      //渲染至页面
      let newArr = [];
      newArr = JSON.parse(JSON.stringify(vm.telArr));
      for (let i = 0; i < newArr.length; i++) {
        newArr[i] = newArr[i]
          .replace(/\s/g, "")
          .replace(/(0?\d{4})(\d{3})(\d{4})/, "$1 $2 $3");
      }
      //赋值输入框
      vm.phone = newArr.join(";\n");
      //条数显示
      vm.Alltotal = vm.telArr.length; //总条数
      //展示当前选择的显示的数据
      vm.showNum(vm.showNumber);
      console.log("正确号码", vm.successArr);
      console.log("错误号码", vm.errorArr);
      console.log("重复号码", vm.repeatArr);
      //把输入框中的号码传给父组件，用于添加号码到标签
      vm.$emit("update:tagAddMobile", vm.telArr);
    },
    getClassify(flag) {
      //将号码分组
      let vm = this;
      let successArr = [];
      if (flag) {
        //父组件点击下一步判断是否有重复号码
        //如果点击确认,则将重复号码加入正确的数组中
        successArr = JSON.parse(
          JSON.stringify(vm.successArr.concat(vm.repeatArr))
        );
      } else {
        successArr = JSON.parse(JSON.stringify(vm.successArr));
      }
      //先将号码段根据当前充值方式以及需要的号码段列别处理一下
      let newArr = JSON.parse(JSON.stringify(vm.operatorList));
      // 1Globe、2Smart、3Sun、4Tnt、5Tm
      let classArr = [];
      for (let num = 0; num < 5; num++) {
        let obj = {};
        let index = num + 1;
        obj.name = "";
        obj.operator_id = index;
        obj.phones = [];
        obj.amount = 0;
        obj.denomination_id = 0;
        obj.content = "";
        obj.showAll = false;
        if (vm.operatorType == 0) {
          obj.denomination = vm.allMoney[index].denomination;
          obj.operator_recharge = vm.allMoney[index].operator_recharge;
          obj.recently = vm.allMoney[index].previous_record;
        }
        classArr.push(obj);
      }
      for (let i = 0; i < newArr.length; i++) {
        for (let j = 0; j < successArr.length; j++) {
          let thisReg = newArr[i].tel + "";
          if (successArr[j].indexOf(thisReg) == 0) {
            let operatorId = newArr[i].operator_id;
            for (let k = 0; k < classArr.length; k++) {
              if (classArr[k].operator_id == operatorId) {
                classArr[k].name = newArr[i].name;
                classArr[k].phones = classArr[k].phones.concat(successArr[j]);
              }
            }
          }
        }
      }
      if (vm.operatorType == 0) {
        //需要Globe Smart Sun，注意，这里需要将tm的号码段合并到Globe中
      } else if (vm.operatorType == 1) {
        //需要Globe Smart Sun Tm
      } else if (vm.operatorType == 2) {
        //需要新增Tnt,Tnt的号码段实际上是等于Smart的号码段，赋值即可
        //并将Smart的号码段清空
        let TntArr = [];
        for (let i = 0; i < classArr.length; i++) {
          let obj = {};
          if (classArr[i].operator_id == 2) {
            obj = classArr[i];
            obj.operator_id = 4;
            obj.name = "Tnt";
            TntArr.push(obj);
          }
        }
        classArr = TntArr;
      }
      let needArr = [];
      for (let i = 0; i < classArr.length; i++) {
        if (classArr[i].phones.length) {
          needArr.push(classArr[i]);
        }
      }
      let data = {};
      data.arr = needArr;
      if (vm.repeatArr.length) {
        data.repeat = true;
      }
      if (vm.errorArr.length) {
        data.error = true;
      }
      return data;
    },
    deleteSubmit(type) {
      //去错去重
      let vm = this;
      let newArr = [];
      if (type || type == 0) {
        if (type == 0) {
          if (!vm.errorArr.length) {
            return;
          }
          vm.errorArr = [];
          newArr = JSON.parse(
            JSON.stringify(vm.successArr.concat(vm.repeatArr))
          );
        } else {
          if (!vm.repeatArr.length) {
            return;
          }
          vm.repeatArr = [];
          newArr = JSON.parse(
            JSON.stringify(vm.successArr.concat(vm.errorArr))
          );
        }
      } else {
        vm.errorArr = [];
        vm.repeatArr = [];
        newArr = JSON.parse(JSON.stringify(vm.successArr));
      }
      for (let i = 0; i < newArr.length; i++) {
        newArr[i] = newArr[i]
          .replace(/\s/g, "")
          .replace(/(0?\d{4})(\d{3})(\d{4})/, "$1 $2 $3");
      }
      vm.telArr = JSON.parse(JSON.stringify(newArr));
      vm.phone = newArr.join(";\n");
      vm.Alltotal = vm.telArr.length;
      vm.showNum(vm.showNumber);
    },
    tabEvent(event) {
      if (event.keyCode == 9) {
        event.currentTarget.value += "\n";
      }
    },
    importPop(type) {
      //点击打开弹窗
      let vm = this;
      if (type == 0) {
        vm.excelFlag = true;
      } else if (type == 1) {
        if (vm.tagList.length) {
          vm.importTelPop = true;
        }
      } else if (type == 2) {
        vm.addTagTelPop = true;
      }
    }
  },
  components: {
    ImportExcel,
    ImportTel,
    AddTag
  },
  watch: {
    rechargeType() {
      let vm = this;
      vm.showNumber = 0; //显示全部/错误/重复号码
      vm.telArr = []; //导入的号码数组
      vm.phone = ""; //输入框的号码
      vm.successArr = []; //输入的号码的成功数组
      vm.errorArr = []; //输入的号码的错误数组
      vm.repeatArr = []; //输入的号码的重复数组
      vm.Alltotal = 0; //总条数
    }
  },
  beforeDestroy() {
    window.removeEventListener("keydown", event => {
      if (event.keyCode === 9) {
        event.preventDefault();
      }
    });
  },
  destroyed() {
    window.removeEventListener("keydown", event => {
      if (event.keyCode === 9) {
        event.preventDefault();
      }
    });
  }
};
</script>
<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.global-dl {
  padding: 0;
  border-top: 0;
}
.number-info {
  padding: 0;
  dd {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .number-title,
    .number-total {
      display: flex;
      justify-content: flex-start;
      line-height: 18px;
    }
    .number-title {
      span {
        color: #333;
        margin-right: 10px;
        font-size: 16px;
      }
    }
    .number-total {
      flex: 1;
      justify-content: flex-end;
      span {
        color: #666;
        padding: 0 9px;
        cursor: pointer;
        &.active {
          position: relative;
          color: #2042ab;
        }
        &.active:after {
          content: "";
          height: 3px;
          width: calc(100% - 18px);
          border-radius: 3px;
          background: #2042ab;
          position: absolute;
          left: 9px;
          bottom: -5px;
        }
      }
      span + span {
        border-left: 1px solid #b6b6b6;
      }
    }
  }
}

.text-warp {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 10px;
  /deep/.ivu-input-wrapper {
    width: 100%;
    .ivu-input {
      border: 0;
    }
  }
  p {
    position: absolute;
    right: 5px;
    bottom: 5px;
    color: #8d959d;
    span {
      margin-left: 10px;
    }
    .error {
      color: red;
    }
    .tisp {
      color: #2042ab;
    }
  }
}
.text-handle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 50px;
  .text-handle-item {
    a {
      text-decoration: underline;
      &.text-gray {
        color: #b6b6b6;
        cursor: no-drop;
      }
    }
    a + a {
      margin-left: 16px;
    }
  }
}
</style>
